module.exports = __webpack_public_path__ + "assets/img/btn-detail-9f320c3d.png";